import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { AuthProvider } from './components/USER/Auth/AuthContext';
import { GPSProvider } from './components/GPS/GPSContext';
import { PermissionsProvider } from './components/USER/Auth/PermissionsContext';
import { ThemeProvider } from './components/UI/ThemeContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <PermissionsProvider>
          <GPSProvider>
            <App />
          </GPSProvider>
        </PermissionsProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// Habilitar Offline Sync y PWA
serviceWorkerRegistration.register();
